import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { HomeRoutingModule } from './home-routing.module';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { StepsStatusComponent } from './pages/steps-status/steps-status.component';
import { PersonalInfoComponent } from './pages/personal-info/personal-info.component';
import { UploadDocumentsComponent } from './pages/upload-documents/upload-documents.component';
import { ContractSignComponent } from './pages/contract-sign/contract-sign.component';
import { OnlineTrainingComponent } from './pages/online-training/online-training.component';
import{SamplePipePipe} from '../shared/pipes/sample-pipe.pipe';
import { DashboardMgaComponent } from './pages/dashboard-mga/dashboard-mga.component';
import { MgaDetailsComponent } from './pages/mga-details/mga-details.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { SalesHomeComponent } from './pages/sales-home/sales-home.component';
import { SalesPolicySearchComponent } from './pages/sales-policy-search/sales-policy-search.component';
import { SavedQuotesComponent } from './pages/saved-quotes/saved-quotes.component';
import { QuotesPurchaseComponent } from './pages/quotes-purchase/quotes-purchase.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { SalesGroupsComponent } from './pages/sales-groups/sales-groups.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { PolicySearchDetailComponent } from './pages/policy-search-detail/policy-search-detail.component';
import { PolicyFullRefundComponent } from './pages/policy-full-refund/policy-full-refund.component';
import { ChangePolicyComponent } from './pages/change-policy/change-policy.component';
import { EditBillingInfoComponent } from './pages/edit-billing-info/edit-billing-info.component';
import { SalesReportComponent } from './pages/sales-report/sales-report.component';
import { ReportDetailsComponent } from './pages/report-details/report-details.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule  } from '@angular/material/core';
import {MomentDateModule,MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { FormsDashboardComponent } from './pages/forms-dashboard/forms-dashboard.component';
import { AgencyAdminDashboardComponent } from './pages/agency-admin-dashboard/agency-admin-dashboard.component';
import { ResourcesDashboardComponent } from './pages/resources-dashboard/resources-dashboard.component';
import { VtcComponent } from './pages/vtc/vtc.component';
import { OfficeAdminSalesReportComponent } from './pages/office-admin-sales-report/office-admin-sales-report.component';
import { OfficeAdminSalesReportDetailsComponent } from './pages/office-admin-sales-report-details/office-admin-sales-report-details.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';

export const MY_FORMATS = {
  parse: {
    dateInput: ['DD-MM-YYYY', 'DD-MMM-YYYY'],
  },
  display: {
    dateInput: 'DDMMMYYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [HomeLayoutComponent, StepsStatusComponent, PersonalInfoComponent, UploadDocumentsComponent, ContractSignComponent, OnlineTrainingComponent,SamplePipePipe, DashboardMgaComponent, MgaDetailsComponent, ContactUsComponent, SalesHomeComponent, SalesPolicySearchComponent, SavedQuotesComponent, QuotesPurchaseComponent, SalesGroupsComponent, PaymentSuccessComponent, PolicySearchDetailComponent, PolicyFullRefundComponent, ChangePolicyComponent, EditBillingInfoComponent,SalesReportComponent, ReportDetailsComponent, FormsDashboardComponent, AgencyAdminDashboardComponent, ResourcesDashboardComponent, OfficeAdminSalesReportComponent, OfficeAdminSalesReportDetailsComponent,VtcComponent
 
  ],
    
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxPaginationModule,
    NgSelectModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatFormFieldModule,
    MomentDateModule,
    RecaptchaV3Module
  ],
  providers: [
    {provide: DateAdapter,useClass: MomentDateAdapter,deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {
          provide: RECAPTCHA_V3_SITE_KEY,
          useValue: '6LcvOU4rAAAAADSer-apdkpVlSOOm8M05DbJ8hgs' 
        }
  ],
})
export class HomeModule { }
